import { RequestInterceptor } from '@rails/request.js'
import * as accounts from './accounts'
import * as adminNotes from './admin/notes'
import * as adminRiaOffices from './admin/ria-offices'
import * as containerSessions from './container-sessions'
import * as identities from './identities'
import * as integrations from './integrations'
import { identityScopeInterceptor } from './interceptors'
import * as reviewSessions from './review-sessions'
import * as submissions from './submissions'
import * as systemNotifications from './system-notifications'

export type { Identity } from './identities'
export type { PriorityOption } from './submissions'

RequestInterceptor.register(identityScopeInterceptor)

export const api = {
  accounts,
  admin: {
    notes: adminNotes,
    riaOffices: adminRiaOffices,
  },
  containerSessions,
  integrations,
  identities,
  reviewSessions,
  submissions,
  systemNotifications,
}
